import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import DictionaryForm from "@/components/dictionaries/DictionaryForm";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import PageContent from "@/components/PageContent";
import { Input } from "@/components/ui/input";
import { isRequired } from "@/lib/form";
import { useShiftReportDepartmentsDictionary } from "@/modules/shiftReportDepartments/hooks/useShiftReportDepartmentsDictionary";
import { useTranslation } from "react-i18next";
import SaveButton from "@/components/SaveButton";

export default function ShiftReportDepartmentForm() {
  const { t } = useTranslation();
  const config = useShiftReportDepartmentsDictionary();
  const { Icon, ns } = config;
  const labels = config.getLabels(t);
  const { mutation } = useDictionaryContext();

  return (
    <DictionaryForm>
      <PageContent
        icon={<Icon className="w-6 h-6 mr-3" />}
        title={labels.title}
        footer={<SaveButton />}
      >
        <Fieldset className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field
            name="name"
            label={t(`${ns}.fields.name`)}
            required={isRequired(config.schema.shape.name)}
            render={({ field }) => (
              <Input
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
        </Fieldset>
        <Fieldset className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Field
            name="description"
            label={t(`${ns}.fields.description`)}
            required={isRequired(config.schema.shape.description)}
            render={({ field }) => (
              <Input
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
        </Fieldset>
      </PageContent>
    </DictionaryForm>
  );
}
